import { queryOptions, useQuery } from '@tanstack/react-query';
import { getWhitelistedPayoutAddresses, mapWhitelistedAddresses } from '@/services/api/whitelisted-payout-addresses';

export const WHITELISTED_PAYOUT_ADDRESSES_QUERY_KEY = ['compliance', 'whitelisted-payout-addresses'] as const;

// Stable reference — an inline select closure would re-run the mapping every render
const selectAddresses = (data: Awaited<ReturnType<typeof getWhitelistedPayoutAddresses>>) => mapWhitelistedAddresses(data.whitelistedAddresses);

export const whitelistedPayoutAddressesQueryOptions = () =>
  queryOptions({
    queryKey: WHITELISTED_PAYOUT_ADDRESSES_QUERY_KEY,
    queryFn: getWhitelistedPayoutAddresses,
    select: selectAddresses,
  });

export const useWhitelistedPayoutAddresses = () => useQuery(whitelistedPayoutAddressesQueryOptions());
